/**
 * App.js
 * Airwallex Payment Demo - React.  Created by Roy Yang and Josie Ku.
 *
 * This file defines all the endpoints for the examples in this app.
 */

import "./App.css";
import React from "react";

import SplitCard from "./components/SplitCard";

function App() {
  return (
    <div className="App">
      <SplitCard />
    </div>
  );
}

export default App;
